import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

import Header from './header';
import { setFetchingLookupData, setLookupData } from '../reducers/tenant-job-entry';
import { getLookUpData } from '../services/services';
import 'react-toastify/dist/ReactToastify.css';
import { getLocalStorage, getSubdomain, setLocalStorage } from '../../helpers/utils';

const LayoutContainer = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(setFetchingLookupData(true));
    const domain = getSubdomain();
    if (domain) {
      getLookUpData({ domain })
        .then((res) => {
          dispatch(setLookupData(res));
          dispatch(setFetchingLookupData(false));
        })
        .catch(() => {
          dispatch(setFetchingLookupData(false));
          toast('Something went wrong.', { type: 'error' });
        });
    }
  }, [dispatch]);

  const getWrapperClassName = useCallback(() => {
    if (location?.pathname === '/work-order-info' || location?.pathname === '/success') {
      return 'no-footer';
    } return '';
  }, [location?.pathname]);

  useEffect(() => {
    const shouldNavToMenu = getLocalStorage('shouldNavToMenu');
    if (shouldNavToMenu && !['/property-info', '/add-new-property']?.includes(window?.location?.pathname)) {
      setLocalStorage('shouldNavToMenu', false);
      const URL = `${window.location.origin}/work-order-info`;
      window.location.replace(URL);
    }
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (!['/property-info', '/add-new-property', '/work-order-info']?.includes(window?.location?.pathname)) {
        setLocalStorage('shouldNavToMenu', true);
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <div>
      <Header />
      <div className={`data-wrapper ${getWrapperClassName()}`}>
        <div className="container">
          {children}
        </div>
      </div>
      <ToastContainer
        position="bottom-right"
        theme="colored"
      />
    </div>
  );
};

export default LayoutContainer;
